import { Link, Typography } from '@evaneos/b2b-ui';
import LuggageIcon from '@evaneos/b2b-ui/icons/LuggageOutlined';

import { useIntl } from 'react-intl';

import { DefinitionList } from '../../../design-system/DefinitionList/DefinitionList';
import { SerializedTripProject } from '../../../resources/dossier/types';
import { useDossierLayoutInfo } from '../DossierLayoutInfoContext';

type ItineraryInfoProps = {
    tripProject: SerializedTripProject;
};

export function ItineraryInfo({ tripProject }: ItineraryInfoProps) {
    const { formatMessage } = useIntl();
    const itineraryUrl =
        typeof tripProject.itineraryUrl?.value === 'string' ? tripProject.itineraryUrl.value : null;
    const itineraryTitle = tripProject.itineraryTitle?.valueTranslated;
    const { isFirstColumnNarrow } = useDossierLayoutInfo();

    if (!itineraryUrl) {
        return null;
    }

    return (
        <DefinitionList.Item>
            <DefinitionList.Label
                id="request-context"
                icon={<LuggageIcon fontSize="small" aria-hidden="true" />}
                iconOnly={isFirstColumnNarrow}
            >
                {formatMessage({ id: 'dossier.information.initial_request.context_title' })}
            </DefinitionList.Label>
            <DefinitionList.StaticValue>
                <Typography variant="body2">
                    {formatMessage({
                        id: 'dossier.information.initial_request.from_itinerary',
                    })}{' '}
                    <Link
                        href={itineraryUrl}
                        target="_blank"
                        rel="noreferrer noopener"
                        data-testid="dossier-initial-request-itinerary_url"
                        fontWeight="bold !important"
                    >
                        {itineraryTitle ||
                            formatMessage({
                                id: 'dossier.information.initial_request.itinerary.url',
                            })}
                    </Link>
                </Typography>
            </DefinitionList.StaticValue>
        </DefinitionList.Item>
    );
}
